
import React from 'react';
import { Control } from 'react-hook-form';
import { Checkbox } from '@/components/ui/checkbox';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormDescription,
} from '@/components/ui/form';
import { useTranslation } from 'react-i18next';
import { TimeSlotFormData } from './timeSlotFormSchema';

interface RecurringModeFieldProps {
  control: Control<TimeSlotFormData>;
}

const RecurringModeField: React.FC<RecurringModeFieldProps> = ({
  control,
}) => {
  const { t } = useTranslation();

  return (
    <FormField
      control={control}
      name="isRecurringMode"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center space-x-2 space-y-0 rounded-md border p-4">
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel className="text-sm font-normal">
              {t('schedule.form.recurringMode')}
            </FormLabel>
            <FormDescription className="text-xs">
              {t('schedule.form.recurringModeDescription')}
            </FormDescription>
          </div>
        </FormItem>
      )}
    />
  );
};

export default RecurringModeField;
